import { useAuth } from "../../app/providers/AuthProvider";

interface VkLoginButtonProps {
  onBeforeLogin?: () => void;
}

export function VkLoginButton({ onBeforeLogin }: VkLoginButtonProps = {}) {
  const { loginWithVK } = useAuth();

  return (
    <button
      type="button"
      onClick={() => {
        onBeforeLogin?.();
        loginWithVK();
      }}
      className="w-full cursor-pointer rounded-2xl border border-line bg-white px-6 py-4 text-base font-semibold text-content transition-colors hover:bg-canvas"
    >
      Войти через VK ID
    </button>
  );
}
